import Big from "big.js";
import dayjs from 'dayjs';
import {Helper as OpeningHelper} from 'bukku/components/Editable/OpeningBalance/helper';
import { getItemFieldObject } from "../../components/Editable/BatchTransaction/utilsCustomFields/getItemFieldObject";
import { RowType } from "../../components/Editable/FormItem/Rows/RowType";
// import { checkFieldsErrorFn } from "../../components/Editable/BatchTransaction/utilsCustomFields/checkFieldsErrorFn";

export const TableName = {
    form_item: "form_item",
    payment_term: "payment_term",
    payment_deposit_item: "payment_deposit_item",

    bank_item: "bank_item",
    journal_item: "journal_item",

    product_unit: "product_unit",
    stock_adjustment: "stock_adjustment",
    stock_transfer: "stock_transfer",
    stock_values: "stock_values",

    batch_asset: 'batch_asset',
    batch_invoice: 'batch_invoice',
    batch_invoice_cash: 'batch_invoice_cash',
    batch_quotation: 'batch_quotation',
    batch_invoice_credit_note: 'batch_invoice_credit_note',
    batch_invoice_payment: 'batch_invoice_payment',
    batch_sale_order: 'batch_sale_order',
    batch_delivery_order: 'batch_delivery_order',
    batch_sale_refund: 'batch_sale_refund',
    batch_purchase_order: 'batch_purchase_order',
    batch_bill: 'batch_bill',
    batch_bill_cash: 'batch_cash_bill',
    batch_bill_expense_claim: 'batch_bill_expense_claim',
    batch_bill_payment: 'batch_bill_payment',
    batch_purchase_credit_note: 'batch_purchase_credit_note',
    batch_bank_income: 'batch_bank_income',
    batch_bank_expense: 'batch_bank_expense',
    batch_journal_entry: 'batch_journal_entry',

    opening_balance: "opening_balance",
    opening_invoice: "opening_invoice",
    opening_bill: "opening_bill",
    opening_stock_adjustment: "opening_stock_adjustment",

    custom_field_dropdown_option: 'custom_field_dropdown_option',

    product_sale_prices: 'product_sale_prices',
    product_purchase_prices: 'product_purchase_prices',
    product_bundle: 'product_bundle',
};

export const TableNames = Object.keys(TableName).map(k => TableName[k]);

function replaceNullWithUndefinedIter(item) {
    const newItem = {...item};

    Object.keys(item).forEach(key => {
        const value = newItem[key];
        if (value === null)
            newItem[key] = undefined;
    });

    if (Array.isArray(newItem.children))
        newItem.children.forEach(replaceNullWithUndefinedIter);
    return newItem;
}

export function getFormFields(tableName, formRef) {
    const formItems = formRef.current.getFieldsValue();
    // console.log('aaa getFormFields', {tableName, formItems});
    switch (tableName) {
        case TableName.form_item:
        case TableName.stock_adjustment:
        case TableName.stock_transfer:
        case TableName.product_sale_prices:
        case TableName.product_purchase_prices:
        case TableName.product_unit:
        case TableName.product_bundle:
        case TableName.payment_term:
        case TableName.payment_deposit_item:
        case TableName.bank_item:
        case TableName.journal_item:
        case TableName.opening_balance:
        case TableName.opening_invoice:
        case TableName.opening_stock_adjustment:
        case TableName.opening_bill:
        case TableName.batch_asset:
        case TableName.batch_invoice:
        case TableName.batch_invoice_cash:
        case TableName.batch_quotation:
        case TableName.batch_invoice_credit_note:
        case TableName.batch_sale_order:
        case TableName.batch_delivery_order:
        case TableName.batch_invoice_payment:
        case TableName.batch_sale_refund:
        case TableName.batch_purchase_order:
        case TableName.batch_bill:
        case TableName.batch_bill_cash:
        case TableName.batch_bill_expense_claim:
        case TableName.batch_bill_payment:
        case TableName.batch_purchase_credit_note:
        case TableName.batch_bank_income:
        case TableName.batch_bank_expense:
        case TableName.batch_journal_entry:
        case TableName.custom_field_dropdown_option:
            return replaceNullWithUndefinedIter(formItems);

        default:
            return {};
    }
}

const parseNumberFn = num => ((num || num === 0) ? num : undefined);
const parseDateFn = dateStr => (dateStr ? dayjs(dateStr, 'YYYY-MM-DD') : undefined);

export function setFormFields(
    tableName, selectedItem,
    context = {fields: {}},
) {
    const item = selectedItem || {};
    const {fields} = context;
    console.log('aaa setFormFields fields', {context, tableName, item});

    function getFormData() {
        switch (tableName) {
            case TableName.stock_adjustment:
                return {
                    product_id: item.product_id,
                    description: item.description,
                    location_id: item.location_id,
                    // quantity_current: parseNumberFn(item.quantity_current),
                    quantity: parseNumberFn(item.quantity),
                    product_unit_id: item.product_unit_id,
                    // quantity_new: parseNumberFn(item.quantity_new),
                    unit_price: parseNumberFn(item.unit_price),

                };

            case TableName.stock_transfer:
                return {
                    product_id: item.product_id,
                    location_id: item.location_id,
                    location2_id: item.location2_id,
                    quantity: parseNumberFn(item.quantity),
                    product_unit_id: item.product_unit_id,
                    description: item.description,

                };
            case TableName.product_unit:
                return {
                    label: item.label,
                    rate: parseNumberFn(item.rate),
                    sale_price: parseNumberFn(item.sale_price),
                    purchase_price: parseNumberFn(item.purchase_price),

                };
            case TableName.form_item:
                return {
                    product_id: item.product_id,
                    description: item.description,
                    service_date: parseDateFn(item.service_date),
                    account_id: item.account_id,
                    quantity: parseNumberFn(item.quantity),
                    product_unit_id: item.product_unit_id,
                    location_id: item.location_id,
                    unit_price: item.unit_price,
                    amount: item.amount,
                    discount: item.discount,
                    tax_code_id: item.tax_code_id,
                };
            case TableName.payment_term:
                return {
                    term_id: item.term_id,
                    date: parseDateFn(item.date),
                    payment_due: item.payment_due,
                    description: item.description,
                };
            case TableName.payment_deposit_item:
                return {
                    payment_method_id: item.payment_method_id,
                    account_id: item.account_id,
                    amount: parseNumberFn(item.amount),
                    number: item.number,
                    fee_amount: item.fee_amount,
                    fee_text: item.fee_text,
                    fee_account_id: item.fee_account_id,
                };

            case TableName.bank_item:
                return {
                    account_id: item.account_id,
                    description: item.description,
                    amount: parseNumberFn(item.amount),
                    tax_code_id: item.tax_code_id,
                };

            case TableName.journal_item:
                return {
                    account_id: item.account_id,
                    description: item.description,
                    debit_amount: parseNumberFn(item.debit_amount),
                    credit_amount: parseNumberFn(item.credit_amount),
                };

            case TableName.batch_asset:
                return {
                    asset_type_id: item.asset_type_id,
                    code: item.code,
                    name: item.name,
                    description: item.description,
                    tag_ids: item.tag_ids,
                    serial_number: item.serial_number,
                    purchase_price: item.purchase_price,
                    cost_limit: item.cost_limit,
                    residual_value: item.residual_value,
                    depreciation_method: item.depreciation_method,
                    depreciation_convention: item.depreciation_convention,
                    depreciate_mode: item.depreciate_mode,
                    useful_life: item.useful_life,
                    depreciation_rate: item.depreciation_rate,
                    depreciated_value: item.depreciated_value,
                    purchase_date: parseDateFn(item.purchase_date),
                    depreciation_start_date: parseDateFn(item.depreciation_start_date),
                    depreciated_date: parseDateFn(item.depreciated_date),

                };
            case TableName.opening_balance:
                return {
                    amount: item.amount || (item.amount ? OpeningHelper.getDefaultAmount(item) : undefined),
                    form_amount: (
                        item.form_amount || (item.amount ? OpeningHelper.getDefaultAmount(item) : '0.00')
                    ),
                    debit: item.amount ? OpeningHelper.getDefaultDebit(item) : '0.00',
                    credit: item.amount ? (OpeningHelper.getDefaultCredit(item)) : '0.00',
                    exchange_rate: parseNumberFn(item.exchange_rate),
                };
            case TableName.opening_invoice:
            case TableName.opening_bill:
                return {
                    contact_id: item.contact_id,
                    number: item.number,
                    number2: item.number2,
                    date: parseDateFn(item.date),
                    due_date: parseDateFn(item.due_date),
                    currency_code: item.currency_code,
                    exchange_rate: parseNumberFn(item.exchange_rate),
                    description: item.description,
                    amount: parseNumberFn(item.amount),
                    tax_code_id: item.tax_code_id || undefined,
                    tag_ids: item.tag_ids,

                    hasNumberError: item.hasNumberError || false,
                    hasNumberErrorMsg: item.hasNumberErrorMsg || null,
                    hasTagIdsErrorMsg: item.hasTagIdsErrorMsg || null,
                    contact_name_not_found: item.contact_name_not_found || false,
                };
            case TableName.opening_stock_adjustment:
                return {
                    product_id: item.product_id,
                    description: item.description,
                    location_id: item.location_id,
                    quantity: parseNumberFn(item.quantity),
                    product_unit_id: item.product_unit_id,
                    unit_price: parseNumberFn(item.unit_price),
                    amount: parseNumberFn(item.amount),
                };
            case TableName.batch_invoice:
                return {
                    contact_id: item.contact_id,
                    title: item.title,
                    number: item.number,
                    number2: item.number2,
                    location_id: item.location_id,
                    date: parseDateFn(item.date),
                    term_id: item.term_id,
                    due_date: parseDateFn(item.due_date),
                    currency_code: item.currency_code,
                    exchange_rate: parseNumberFn(item.exchange_rate),
                    tag_ids: item.tag_ids,
                    product_id: item.product_id,
                    account_id: item.account_id,
                    description: item.description,
                    master_description: item.master_description,
                    quantity: parseNumberFn(item.quantity),
                    unit_price: parseNumberFn(item.unit_price),
                    discount: item.discount,
                    tax_code_id: item.tax_code_id,
                    product_unit_id: item.product_unit_id,
                    // notFound: item.notFound,
                    ...getItemFieldObject(fields, tableName, item),
                };
            case TableName.batch_sale_order:
            case TableName.batch_invoice_cash:
                return {
                    contact_id: item.contact_id,
                    title: item.title,
                    number: item.number,
                    number2: item.number2,
                    location_id: item.location_id,
                    date: parseDateFn(item.date),
                    currency_code: item.currency_code,
                    exchange_rate: parseNumberFn(item.exchange_rate),
                    payment_account_id: item.payment_account_id,
                    tag_ids: item.tag_ids,
                    product_id: item.product_id,
                    account_id: item.account_id,
                    description: item.description,
                    master_description: item.master_description,
                    quantity: parseNumberFn(item.quantity),
                    unit_price: parseNumberFn(item.unit_price),
                    amount: parseNumberFn(item.amount),
                    discount: item.discount,
                    tax_code_id: item.tax_code_id,
                    product_unit_id: item.product_unit_id,
                    ...getItemFieldObject(fields, tableName, item),
                };
            case TableName.batch_delivery_order:
            case TableName.batch_quotation:
                return {
                    contact_id: item.contact_id,
                    title: item.title,
                    number: item.number,
                    number2: item.number2,
                    location_id: item.location_id,
                    date: parseDateFn(item.date),
                    currency_code: item.currency_code,
                    exchange_rate: parseNumberFn(item.exchange_rate),
                    tag_ids: item.tag_ids,
                    product_id: item.product_id,
                    account_id: item.account_id,
                    description: item.description,
                    master_description: item.master_description,
                    quantity: parseNumberFn(item.quantity),
                    unit_price: parseNumberFn(item.unit_price),
                    amount: parseNumberFn(item.amount),
                    discount: item.discount,
                    tax_code_id: item.tax_code_id,
                    product_unit_id: item.product_unit_id,
                };
            case TableName.batch_invoice_credit_note:
                return {
                    contact_id: item.contact_id,
                    title: item.title,
                    number: item.number,
                    number2: item.number2,
                    date: parseDateFn(item.date),
                    currency_code: item.currency_code,
                    exchange_rate: parseNumberFn(item.exchange_rate),
                    tag_ids: item.tag_ids,
                    product_id: item.product_id,
                    account_id: item.account_id,
                    description: item.description,
                    master_description: item.master_description,
                    quantity: parseNumberFn(item.quantity),
                    product_unit_id: item.product_unit_id,
                    location_id: item.location_id,
                    unit_price: parseNumberFn(item.unit_price),
                    amount: parseNumberFn(item.amount),
                    discount: item.discount,
                    tax_code_id: item.tax_code_id,
                };
            case TableName.batch_invoice_payment:
                return {
                    contact_id: item.contact_id,
                    number: item.number,
                    number2: item.number2,
                    date: parseDateFn(item.date),
                    currency_code: item.currency_code,
                    exchange_rate: parseNumberFn(item.exchange_rate),
                    amount: parseNumberFn(item.amount),
                    payment_method: item.payment_method,
                    fee_text: item.fee_text,
                    fee_account_id: item.fee_account_id,
                    discount: item.discount,
                    account_id: item.account_id,
                    tag_ids: item.tag_ids,
                    title: item.title,
                    description: item.description,
                    master_description: item.master_description,

                    target_transaction_id: item.target_transaction_id,
                    balance: parseNumberFn(item.balance),
                    apply_amount: parseNumberFn(item.apply_amount),
                };
            case TableName.batch_sale_refund:
                return {
                    contact_id: item.contact_id,
                    number: item.number,
                    number2: item.number2,
                    date: parseDateFn(item.date),
                    currency_code: item.currency_code,
                    exchange_rate: parseNumberFn(item.exchange_rate),
                    amount: parseNumberFn(item.amount),
                    discount: item.discount,
                    account_id: item.account_id,
                    tag_ids: item.tag_ids,
                    title: item.title,
                    description: item.description,
                    master_description: item.master_description,

                    target_transaction_id: item.target_transaction_id,
                    balance: parseNumberFn(item.balance),
                    apply_amount: parseNumberFn(item.apply_amount),
                };
            // Purchase orders
            case TableName.batch_purchase_order:
                return {
                    contact_id: item.contact_id,
                    number: item.number,
                    number2: item.number2,
                    date: parseDateFn(item.date),
                    currency_code: item.currency_code,
                    exchange_rate: parseNumberFn(item.exchange_rate),
                    tag_ids: item.tag_ids,
                    title: item.title,
                    master_description: item.master_description,
                    // Items
                    product_id: item.product_id,
                    account_id: item.account_id,
                    description: item.description,
                    quantity: parseNumberFn(item.quantity),
                    product_unit_id: item.product_unit_id,
                    location_id: item.location_id,
                    unit_price: parseNumberFn(item.unit_price),
                    discount: item.discount,
                    tax_code_id: item.tax_code_id,
                };
            // Purchase bills
            case TableName.batch_bill:
                return {
                    contact_id: item.contact_id,
                    number: item.number,
                    number2: item.number2,
                    date: parseDateFn(item.date),
                    term_id: item.term_id,
                    due_date: parseDateFn(item.due_date),
                    currency_code: item.currency_code,
                    exchange_rate: parseNumberFn(item.exchange_rate),
                    tag_ids: item.tag_ids,
                    product_id: item.product_id,
                    account_id: item.account_id,
                    description: item.description,
                    master_description: item.master_description,
                    quantity: parseNumberFn(item.quantity),
                    product_unit_id: item.product_unit_id,
                    location_id: item.location_id,
                    unit_price: parseNumberFn(item.unit_price),
                    discount: item.discount,
                    tax_code_id: item.tax_code_id,
                    title: item.title,
                };
            case TableName.batch_bill_cash:
                return {
                    contact_id: item.contact_id,
                    number: item.number,
                    number2: item.number2,
                    date: parseDateFn(item.date),
                    due_date: parseDateFn(item.due_date),
                    currency_code: item.currency_code,
                    exchange_rate: parseNumberFn(item.exchange_rate),
                    payment_account_id: item.payment_account_id,
                    tag_ids: item.tag_ids,
                    product_id: item.product_id,
                    account_id: item.account_id,
                    description: item.description,
                    master_description: item.master_description,
                    quantity: parseNumberFn(item.quantity),
                    product_unit_id: item.product_unit_id,
                    location_id: item.location_id,
                    unit_price: parseNumberFn(item.unit_price),
                    discount: item.discount,
                    tax_code_id: item.tax_code_id,
                    title: item.title,
                };
            case TableName.batch_bill_expense_claim:
                return {
                    contact_id: item.contact_id,
                    contact2_id: item.contact2_id,
                    number: item.number,
                    number2: item.number2,
                    date: parseDateFn(item.date),
                    term_id: item.term_id,
                    due_date: parseDateFn(item.due_date),
                    currency_code: item.currency_code,
                    exchange_rate: parseNumberFn(item.exchange_rate),
                    tag_ids: item.tag_ids,
                    product_id: item.product_id,
                    account_id: item.account_id,
                    description: item.description,
                    master_description: item.master_description,
                    quantity: parseNumberFn(item.quantity),
                    product_unit_id: item.product_unit_id,
                    location_id: item.location_id,
                    unit_price: parseNumberFn(item.unit_price),
                    discount: item.discount,
                    tax_code_id: item.tax_code_id,
                    title: item.title,
                };
            case TableName.batch_bill_payment:
                return {
                    contact_id: item.contact_id,
                    number: item.number,
                    number2: item.number2,
                    date: parseDateFn(item.date),
                    currency_code: item.currency_code,
                    exchange_rate: parseNumberFn(item.exchange_rate),
                    amount: parseNumberFn(item.amount),
                    payment_method: item.payment_method,
                    fee_text: item.fee_text,
                    fee_account_id: item.fee_account_id,
                    discount: item.discount,
                    account_id: item.account_id,
                    tag_ids: item.tag_ids,
                    description: item.description,
                    master_description: item.master_description,

                    target_transaction_id: item.target_transaction_id,
                    balance: parseNumberFn(item.balance),
                    apply_amount: parseNumberFn(item.apply_amount),
                    title: item.title,
                };
            case TableName.batch_purchase_credit_note:
                return {
                    contact_id: item.contact_id,
                    title: item.title,
                    number: item.number,
                    number2: item.number2,
                    date: parseDateFn(item.date),
                    currency_code: item.currency_code,
                    exchange_rate: parseNumberFn(item.exchange_rate),
                    tag_ids: item.tag_ids,
                    product_id: item.product_id,
                    account_id: item.account_id,
                    description: item.description,
                    master_description: item.master_description,
                    quantity: parseNumberFn(item.quantity),
                    product_unit_id: item.product_unit_id,
                    location_id: item.location_id,
                    unit_price: parseNumberFn(item.unit_price),
                    amount: parseNumberFn(item.amount),
                    discount: item.discount,
                    tax_code_id: item.tax_code_id,
                };
            case TableName.batch_bank_income:
            case TableName.batch_bank_expense:
                return {
                    contact_id: item.contact_id,
                    number: item.number,
                    number2: item.number2,
                    date: parseDateFn(item.date),
                    currency_code: item.currency_code,
                    exchange_rate: parseNumberFn(item.exchange_rate),
                    bank_account_id: item.bank_account_id,
                    tag_ids: item.tag_ids,
                    account_id: item.account_id,
                    description: item.description,
                    master_description: item.master_description,
                    amount: parseNumberFn(item.amount),
                    tax_code_id: item.tax_code_id,
                    title: item.title,
                    ...getItemFieldObject(fields, tableName, item),
                };
            case TableName.batch_journal_entry:
                return {
                    number: item.number,
                    number2: item.number2,
                    date: parseDateFn(item.date),
                    currency_code: item.currency_code,
                    exchange_rate: parseNumberFn(item.exchange_rate),
                    tag_ids: item.tag_ids,
                    master_description: item.master_description,
                    // Items
                    account_id: item.account_id,
                    description: item.description,
                    debit_amount: parseNumberFn(item.debit_amount),
                    credit_amount: parseNumberFn(item.credit_amount),
                };
            case TableName.custom_field_dropdown_option:
                return {
                    item: item.item,
                };
            case TableName.product_sale_prices:
            case TableName.product_purchase_prices:
                return {
                    price_level_id: item.price_level_id,
                    contact_id: item.contact_id,
                    date_from: parseDateFn(item.date_from),
                    date_to: parseDateFn(item.date_to),
                    minimum_quantity: parseNumberFn(item.minimum_quantity),
                    product_unit_id: item.product_unit_id,
                    currency_code: item.currency_code,
                    unit_price: parseNumberFn(item.unit_price),
                };
            case TableName.product_bundle:
                return {
                    product_id: item.product_id,
                    quantity: parseNumberFn(item.quantity),
                    product_unit_id: item.product_unit_id,
                    sale_discount_amount: parseNumberFn(item.sale_discount_amount),
                    purchase_discount_amount: parseNumberFn(item.purchase_discount_amount),
                };
            default:
                return {};
        }
    }

    const formData = getFormData();
    return replaceNullWithUndefinedIter(formData);
}

function iterFormItemHasErrorFn(item) {
    switch (item.type) {
        case 'subtotal':
            return false; // no checking
        case 'subtitle':
            return !item.description;
        case 'bundle': {
            if (item.children) {
                const hasError = item.children.filter(child => iterFormItemHasErrorFn(child)).length > 0;
                if (hasError)
                    return true;
            }

            // No checking for transferred items
            if (item.transfer_transaction)
                return false;

            return (
                !item.product_id ||
                    !item.description
                    // (item.quantity === '' || item.quantity === undefined || item.quantity === null)
            );
        }
        case RowType.bundle_discount:
            // No checking for transferred items
            if (item.transfer_transaction)
                return false;

            return (
                !item.description ||
                    !item.account_id
            );
        case 'product':
        case 'bundle_item':
        default:
            // No checking for transferred items
            if (item.transfer_transaction)
                return false;

            return (
                !item.description ||
                    !item.account_id ||
                    // (item.quantity === '' || item.quantity === undefined || item.quantity === null) ||
                    (item.unit_price === '' || item.unit_price === undefined || item.unit_price === null)
            );
    }
}
export function hasErrorFn(tableName, item, params, context = {}) {
    const { fields } = context;
    console.log('aaa hasErrorFn', {item, params, context, fields});
    switch (tableName) {
        case TableName.form_item: {
            return iterFormItemHasErrorFn(item);
        }
        case TableName.payment_term: {
            const isRecurring = params.isRecurring || false;
            if (
                (isRecurring && (!item.payment_due || !item.term_id)) ||
                (!isRecurring && (!item.payment_due || (!item.date && !item.term_id)))
            )
                return true;

            return false;
        }

        case TableName.payment_deposit_item: {
            if (!item.account_id)
                return true;

            return false;
        }

        case TableName.bank_item:
            if (!item.description || !item.account_id)
                return true;
            if (!item.amount && item.amount !== 0)
                return true;
            return false;

        case TableName.journal_item:
            if (!item.description ||
                !item.account_id ||
                (
                    new Big(parseFloat(item.debit_amount) || 0).eq(0) &&
                    new Big(parseFloat(item.credit_amount) || 0).eq(0)
                )
            )
                return true;
            return false;

        case TableName.custom_field_dropdown_option:
            return !item.item;

            // case TableName.batch_invoice:
            // case TableName.batch_invoice_cash:
            //     return checkFieldsErrorFn(fields, item, tableName);

        case TableName.opening_invoice:
        case TableName.opening_bill:
            return (
                !item.contact_id ||
                !item.number ||
                !item.date ||
                !item.exchange_rate ||
                !item.description ||
                (item.amount === undefined || item.amount === '' || item.amount === null)
            );

        case TableName.opening_stock_adjustment:
            return (
                !item.product_id ||
                !item.description ||
                !item.location_id ||
                !item.quantity ||
                (!item.unit_price && parseFloat(item.unit_price) !== 0) ||
                !item.product_unit_id
            );

        default:
            return false;
    }
}
